import classes from './types/classes';
import activeWitchDoctorSkills from './skills/activeWitchDoctorSkills';
import passiveWitchDoctorSkills from './skills/passiveWitchDoctorSkills';
import activeMonkSkills from './skills/activeMonkSkills';
import passiveMonkSkills from './skills/passiveMonkSkills';
import passiveBarbarianSkills from './skills/passiveBarbarianSkills';
import activeWizardSkills from './skills/activeWizardSkills';
import passiveWizardSkills from './skills/passiveWizardSkills';
import activeBarbarianSkills from './skills/activeBarbarianSkills';
import activeNecromancerSkills from './skills/activeNecromancerSkills';
import passiveNecromancerSkills from './skills/passiveNecromancerSkills';
import activeDemonHunterSkills from './skills/activeDemonHunterSkills';
import passiveDemonHunterSkills from './skills/passiveDemonHunterSkills';
import activeCrusaderSkills from './skills/activeCrusaderSkills';
import passiveCrusaderSkills from './skills/passiveCrusaderSkills';
import WizardBW from '../assets/images/WizardBW.png';
import BarbarianBW from '../assets/images/BarbarianBW.png';
import WitchDoctorBW from '../assets/images/WitchDoctorBW.png';
import CrusaderBW from '../assets/images/CrusaderBW.png';
import DemonHunterBW from '../assets/images/DemonHunterBW.png';
import MonkBW from '../assets/images/MonkBW.png';
import NecromancerBW from '../assets/images/NecromancerBW.png';

const {
  barbarian,
  wizard,
  witchDoctor,
  demonHunter,
  monk,
  necromancer,
  crusader,
} = classes;

export default {
  [wizard]: {
    id: 1,
    displayName: 'Wizard',
    class: wizard,
    skills: activeWizardSkills,
    passives: passiveWizardSkills,
    imageUrl: WizardBW,
  },
  [demonHunter]: {
    id: 2,
    class: demonHunter,
    displayName: 'Demon Hunter',
    skills: activeDemonHunterSkills,
    passives: passiveDemonHunterSkills,
    imageUrl: DemonHunterBW,
  },
  [crusader]: {
    id: 3,
    class: crusader,
    displayName: 'Crusader',
    skills: activeCrusaderSkills,
    passives: passiveCrusaderSkills,
    imageUrl: CrusaderBW,
  },
  [necromancer]: {
    id: 4,
    class: necromancer,
    displayName: 'Necromancer',
    skills: activeNecromancerSkills,
    passives: passiveNecromancerSkills,
    imageUrl: NecromancerBW,
  },
  [witchDoctor]: {
    id: 5,
    class: witchDoctor,
    displayName: 'Witch Doctor',
    skills: activeWitchDoctorSkills,
    passives: passiveWitchDoctorSkills,
    imageUrl: WitchDoctorBW,
  },
  [barbarian]: {
    id: 6,
    class: barbarian,
    displayName: 'Barbarian',
    skills: activeBarbarianSkills,
    passives: passiveBarbarianSkills,
    imageUrl: BarbarianBW,
  },
  [monk]: {
    id: 7,
    class: monk,
    displayName: 'Monk',
    skills: activeMonkSkills,
    passives: passiveMonkSkills,
    imageUrl: MonkBW,
  },
};
